import {LocalDate, nativeJs} from 'js-joda'
import DatePicker from 'material-ui/DatePicker'
import MenuItem from 'material-ui/MenuItem'
import SelectField from 'material-ui/SelectField'
import TextField from 'material-ui/TextField'
import * as R from 'ramda'
import * as React from 'react'
import * as Autosuggest from 'react-autosuggest'
import * as Nullable from '../../../Data/Nullable'
import * as PrismaManufacturerStatus
    from '../../../Entities/PrismaManufacturerStatus'
import * as BpsUser from '../../../Entities/BpsUser'
import {FilterForm} from '../../../View/Filtering/FilterForm'
import {
    renderSuggestion,
    renderSuggestionsContainer,
    shouldRenderSuggestions
} from '../../../View/MaterialAutosuggest'
import * as PrismaRequestFilteringState
    from '../Model/PrismaRequestFilteringState'
import * as PrismaRequestFilterInput from '../Model/PrismaRequestFilterInput'
import * as PrismaRequestFilterType from '../Model/PrismaRequestFilterType'
import {PrismaRequestFilteringAction} from '../PrismaRequestFilteringActions'
import TextFieldProps = __MaterialUI.TextFieldProps

export function PrismaRequestFilterForm({state, dispatch}: {
    state: PrismaRequestFilteringState.M,
    dispatch: (action: PrismaRequestFilteringAction) => void,
}) {
    return (
        <FilterForm
            filterTypeLabel={PrismaRequestFilterType.label}
            state={state}
            onFilterSelectChanged={
                (value: PrismaRequestFilterType.M) =>
                    dispatch({type: 'FilterSelectChanged', value})
            }
            onAddFilter={() => dispatch({type: 'AddFilter'})}
            onClearFilters={() => dispatch({type: 'ResetFilters'})}
            filterInputView={
                (filterInput: PrismaRequestFilterInput.M) => (
                    <FilterInputView
                        addFilterInput={filterInput}
                        dispatch={dispatch}
                    />
                )
            }
        />
    )
}

function FilterInputView({addFilterInput, dispatch}: {
    addFilterInput: PrismaRequestFilterInput.M,
    dispatch: (action: PrismaRequestFilteringAction) => void
}): JSX.Element {
    switch (addFilterInput.type) {
        case 'BpsUserFilterInput':
            return (
                <Autosuggest
                    suggestions={addFilterInput.bpsUserSuggestions}
                    onSuggestionsFetchRequested={
                        (value: string) => dispatch({
                            type: 'FetchBpsUserSuggestions',
                            value,
                        })}
                    onSuggestionsClearRequested={
                        () => dispatch({
                            type: 'ClearBpsUserSuggestions',
                        })}
                    getSuggestionValue={
                        (nullableBpsUser: BpsUser.BpsUser | null) =>
                            Nullable.map(BpsUser.label, nullableBpsUser)
                    }
                    inputProps={{
                        value: addFilterInput.bpsUserSearch,
                        onChange: (
                            // tslint:disable-next-line
                            event: any,
                            {newValue}: { newValue: string }
                        ) => dispatch({
                            type: 'BpsUserSearchChanged',
                            value: newValue,
                        }),
                    }}
                    onSuggestionSelected={
                        (
                            // tslint:disable-next-line
                            event: any,
                            {suggestion}: { suggestion: BpsUser.BpsUser }
                        ) => dispatch({
                            type: 'InputChanged',
                            subAction: {
                                type: 'BpsUserChanged',
                                value: suggestion,
                            },
                        })}
                    renderInputComponent={
                        (inputProps: TextFieldProps) =>
                            (
                                <TextField
                                    {...inputProps}
                                    floatingLabelText="BpsUser"
                                    fullWidth={true}
                                />
                            )
                    }
                    renderSuggestionsContainer={renderSuggestionsContainer}
                    renderSuggestion={
                        renderSuggestion(
                            (suggestion: BpsUser.BpsUser) =>
                                `${suggestion.firstName} ${suggestion.lastName}`)
                    }
                    shouldRenderSuggestions={shouldRenderSuggestions}
                />
            )
        case 'CreatedFromFilterInput':
            return (
                <DatePicker
                    hintText="Datum von"
                    floatingLabelText="Bestellungen anzeigen von"
                    value={addFilterInput.value !== null ? new Date(addFilterInput.value.toString()) : undefined}
                    dialogContainerStyle={{zIndex: 3000}}
                    onChange={(event, value: Date) =>
                        dispatch({
                            type: 'InputChanged',
                            subAction: {
                                type: 'CreatedFromChanged',
                                value: LocalDate.from(nativeJs(value)),
                            },
                        })}
                />)
        case 'CreatedToFilterInput':
            return (
                <DatePicker
                    hintText="Datum bis"
                    floatingLabelText="Bestellungen anzeigen bis"
                    value={addFilterInput.value !== null ? new Date(addFilterInput.value.toString()) : undefined}
                    dialogContainerStyle={{zIndex: 3000}}
                    onChange={(event, value: Date) =>
                        dispatch({
                            type: 'InputChanged',
                            subAction: {
                                type: 'CreatedToChanged',
                                value: LocalDate.from(nativeJs(value)),
                            }
                        })}
                />)
        case 'StatusFilterInput':
            return (
                <SelectField
                    className="filter__select"
                    floatingLabelText="Status"
                    value={addFilterInput.value}
                    onChange={(
                        event,
                        key,
                        value: PrismaManufacturerStatus.M
                    ) =>
                        dispatch({
                            type: 'InputChanged',
                            subAction: {type: 'StatusChanged', value}
                        })}
                >
                    {R.map(
                        status =>
                            <MenuItem
                                value={status}
                                primaryText={
                                    PrismaManufacturerStatus.label(status)
                                }
                            />,
                        PrismaManufacturerStatus.all(),
                    )}
                </SelectField>
            )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/PrismaRequestFiltering/View/PrismaRequestFilterForm.tsx